export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/ce82aae38e929df8fcdd7e760ce92d73.svg";